module.exports = __webpack_public_path__ + "img/diners.b5353841.png";